import anc from "../ProjectImage/chaitanya.png";
import srv from "../ProjectImage/schoolLogo.jpg";
import nit from "../ProjectImage/lpu.jpg";

export const Educations = [
    {
      id: 1,
      logo: nit, // Add logo if available
      title: "Bachelor of Technology - Computer Science and Engineering; CGPA: 7.75",
      duration: "Jun 2022 – May 2025",
      institution: "Lovely Professional University, Punjab, India",
    },
    {
      id: 2,
      logo: srv, // Add logo if available
      title: "Intermediate; Percentage: 96%",
      duration: "Jun 2020 – May 2022",
      institution: "Sri Chaitanya Junior College, Hyderabad, Telangana",
    },
    {
      id: 3,
      logo: anc, // Add logo if available
      title: "Matriculation; CGPA: 10",
      duration: "Jun 2019 – May 2020",
      institution: "Sri Chandra High School, Nizamabad, Telangana",
    }
]



